import { QueryClient } from '@tanstack/react-query'

export function criarQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Tela do posto precisa ser confiável offline: dado em cache vale
        // até o servidor responder, nada de spinner a cada foco de janela.
        staleTime: 15_000,
        gcTime: 24 * 60 * 60_000,
        retry: (tentativa, erro) => {
          const codigo = (erro as { data?: { code?: string } }).data?.code
          if (codigo === 'UNAUTHORIZED' || codigo === 'FORBIDDEN' || codigo === 'NOT_FOUND')
            return false
          return tentativa < 3
        },
        refetchOnWindowFocus: false,
      },
      mutations: { retry: 0 },
    },
  })
}

/** Áreas do tRPC que o tablet precisa para seguir trabalhando sem rede. */
const AREAS_DO_POSTO = new Set(['apontamento', 'auth', 'dispositivos', 'postos'])

/**
 * O tablet não pode depender da rede para mostrar o que já sabia: a fila, a
 * sessão e o posto ficam guardados no aparelho e voltam mesmo se o app for
 * reaberto sem Wi-Fi (o que o operador tocou vem do outbox, por cima). Só
 * dado do posto; superjson preserva as datas.
 */
export function deveGuardarNoAparelho(queryKey: readonly unknown[]): boolean {
  const caminho = queryKey[0]
  return Array.isArray(caminho) && AREAS_DO_POSTO.has(caminho[0] as string)
}

export const MAX_IDADE_CACHE_MS = 24 * 60 * 60_000
/** Suba quando o formato de uma resposta guardada mudar: o cache antigo é descartado. */
export const VERSAO_CACHE = '1'
